<!-- ***** SG-7344 START ***** -->
<div class="main-body">
  <div class="heading">
    <span cardHeader fxLayoutAlign="start center" class="warning-span">
      <mat-icon 
        color="warn" 
        style="margin-right: 8px !important; margin-bottom: 13px !important; color: #F6610C !important">
        warning
      </mat-icon>
      <span class="warning-title">{{ title }}</span>
    </span>

    <div>
      <mat-icon pointer mat-dialog-close class="close">close</mat-icon>
    </div>
  </div>
    
    <mat-divider class="divider"></mat-divider>
    
    <div class="content-container">
      <mat-dialog-content class="dialog-content">{{ text }}</mat-dialog-content>
      
      <div class="actions-container">
        <mat-dialog-actions fxLayout="row" fxLayoutAlign="end">  <!-- SG - 7194 -->
          <button mat-button [mat-dialog-close]="true" class="save-button">{{ buttonSave }}</button>
          <button mat-button mat-dialog-close class="cancel-button">{{ buttonCancel }}</button>
        </mat-dialog-actions>
      </div>
    </div>
  <div>
</div>
<!-- ***** SG-7344 END ***** -->
